import React from 'react';
import Loading from '@/pages/dashboard/components/Loadings';

import './ComponentProxy.scss';

interface Props {
  loading: boolean;
  noData: boolean;
  noDataText?: any;
  height?: string | number;
  componentRender: () => React.ReactElement;
}

const ComponentProxy = (props: Props) => {
  const { loading = false, noData = false, noDataText = 'no data', height = '200px', componentRender } = props;

  if (loading) {
    return <Loading style={{ height }} />;
  }

  if (noData) {
    return (
      <div className="component-proxy-nodata-box" style={{ height }}>
        {noDataText}
      </div>
    );
  }

  return componentRender();
};

export default ComponentProxy;
